import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseDataManagementEffects, baseDataManagementReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('dataManagement', baseDataManagementReducer.BaseDataManagementReducer),
    EffectsModule.forFeature([baseDataManagementEffects.BaseDataManagementEffects]),
  ],
})
export class BaseDataManagementStoreModule {}
